module.exports = __webpack_public_path__ + "TT.png?cf3c1a52c5361f3827859cc10dbc2012";